import { Card, Col, Input, Pagination, Row, Select, Spin, Table, Modal, Button, Steps } from "antd";
import { Option } from "antd/es/mentions";
import { LoadingOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import { LIST_CAMPAIGN_USER,LIST_DEPARTMENTS } from "../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../components/CulsightPageLoader";

const { Step } = Steps;

function CampaignUsers(props) {
  const { campaign_id, filterStatus, setLoadingUsers } = props;
  const [page_size, set_page_size] = useState(10);

  // State variables
  const [loader, setLoader] = useState(true); // initial page loader
  const [pagination_loader, set_pagination_loader] = useState(false); // loader for pagination/search actions
  const [table_data, set_table_data] = useState(false);
  const [current_page, set_current_page] = useState("");
  const [total_pages, set_total_pages] = useState("");
  const [total_users, set_total_users] = useState("");

  // Search states (separated for clarity)
  const [emailValue, setEmailValue] = useState("");
  const [statusValue, setStatusValue] = useState(""); // will hold numeric string like "0","1",...

  // Modal state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [departmentList, setDepartmentList] = useState([]);
const [departmentValue, setDepartmentValue] = useState("");

const handleDepartmentChange = (val) => {
  setDepartmentValue(val);
  setStatusValue("");
  setEmailValue("");

  const FORM_DATA = new FormData();
  FORM_DATA.append("campaign_id", campaign_id);

  if (val) {
    FORM_DATA.append("department", val); // 👈 string value
  }

  fetchResultsDebounced(FORM_DATA);
};
  // ================= GET DEPARTMENTS =================
  useEffect(() => {
    const GET_DEPARTMENTS = async () => {
      try {
        const res = await LIST_DEPARTMENTS(); // list-departments/
        if (res?.data?.status) {
          setDepartmentList(res.data.data || []);
        }
      } catch (err) {
        console.error("Department API Error:", err);
      }
    };

    GET_DEPARTMENTS();
  }, []);

  const showModal = (record) => {
    setSelectedUser(record);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const STATUS_OPTIONS = [
    { label: "All ", value: "all" },
    { label: " Sent", value: "1" },
    { label: "Opened", value: "2" },
    { label: "Clicked ", value: "3" },
    { label: "Submitted ", value: "4" }
  ];

  // unified fetch function (used by debounce wrapper)
  const fetchResultsDebounced = useCallback(
    debounce(async (formData) => {
      try {
        set_pagination_loader(true);
        const API_CALL = await LIST_CAMPAIGN_USER(formData);
        if (API_CALL?.data?.status) {
          set_table_data(API_CALL?.data?.data);
          set_current_page(API_CALL?.data?.current_page);
          set_total_pages(API_CALL?.data?.total_pages);
          set_total_users(API_CALL?.data?.total_users);
        } else {
          set_table_data([]);
        }
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        set_pagination_loader(false);
        // ensure parent loader also turned off if it was set by chart click
        if (typeof setLoadingUsers === "function") setLoadingUsers(false);
      }
    }, 500),
    [campaign_id]
  );

  // wrapper to call the debounced fetch with key/value
  const fetchResults = (search_key, search_value) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("campaign_id", campaign_id);
    if (search_key && search_value !== undefined && search_value !== null && search_value !== "") {
      // if key is status and value is number 0.. then append as number
      FORM_DATA.append(search_key, search_value);
    }
    fetchResultsDebounced(FORM_DATA);
  };

  // initial load
  useEffect(() => {
    const LIST_API = async () => {
      setLoader(true);
      try {
        const FORM_DATA = new FormData();
        FORM_DATA.append("campaign_id", campaign_id);
        const API_CALL = await LIST_CAMPAIGN_USER(FORM_DATA);
        if (API_CALL?.data?.status) {
          set_table_data(API_CALL?.data?.data);
          set_current_page(API_CALL?.data?.current_page);
          set_total_pages(API_CALL?.data?.total_pages);
          set_total_users(API_CALL?.data?.total_users);
        } else {
          set_table_data([]);
        }
      } catch (err) {
        console.error("LIST_API Error:", err);
      } finally {
        setLoader(false);
      }
    };

    LIST_API();
  }, [campaign_id]);


  useEffect(() => {
    if (filterStatus !== "" && filterStatus !== null && filterStatus !== undefined) {

      setEmailValue("");
      setStatusValue(filterStatus);

      (async () => {
        if (typeof setLoadingUsers === "function") setLoadingUsers(true);
        set_pagination_loader(true);
        try {
          const FORM_DATA = new FormData();
          FORM_DATA.append("campaign_id", campaign_id);
          FORM_DATA.append("status", Number(filterStatus));
          const API_CALL = await LIST_CAMPAIGN_USER(FORM_DATA);
          if (API_CALL?.data?.status) {
            set_table_data(API_CALL?.data?.data);
            set_current_page(API_CALL?.data?.current_page);
            set_total_pages(API_CALL?.data?.total_pages);
            set_total_users(API_CALL?.data?.total_users);
          } else {
            set_table_data([]);
          }
        } catch (err) {
          console.error("Filter API Error:", err);
        } finally {
          set_pagination_loader(false);
          if (typeof setLoadingUsers === "function") setLoadingUsers(false);
        }
      })();
    }
  }, [filterStatus, campaign_id, setLoadingUsers]);

  const selectBefore = (
    <Select
      defaultValue="email"
      style={{ width: 80 }}
    >
      <Option value="email">Email</Option>
    </Select>
  );

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (_, record) => <span>{record.name}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (_, record) => <span>{record.email}</span>,
    },
    {
      title: "Phone",
      dataIndex: "contact_no",
      render: (_, record) => <span>{record.contact_no || "No Data"}</span>,
    },
     {
      title: "Department",
      dataIndex: "department",
      render: (_, record) => <span>{record.department || "No Data"}</span>,
    },
    {
      title: "Status",
      render: (_, record) => (
        <>
          {record?.tracking_data?.tracking_status === 0 && (
            <span style={{ color: "#8c3add" }}>Email Sent</span>
          )}
          {record?.tracking_data?.tracking_status === 1 && (
            <span style={{ color: "#1fa7a1" }}>Email Opened</span>
          )}
          {record?.tracking_data?.tracking_status === 2 && (
            <span style={{ color: "#eab451" }}>Clicked Link</span>
          )}
          {record?.tracking_data?.tracking_status === 3 && (
            <span style={{ color: "#b37feb" }}>Submitted Data</span>
          )}
          {record?.tracking_data?.tracking_status === 200 && (
            <span style={{ color: "#f97d7d" }}>Spam Email</span>
          )}
          {record?.tracking_data?.tracking_status === 522 && (
            <span style={{ color: "#f97d7d" }}>Spam + Copyright</span>
          )}
          {record?.tracking_data?.tracking_status === 523 && (
            <span style={{ color: "#ad3a05ff" }}>Bot Detection</span>
          )}
        </>
      ),
    },
    {
      title: "Button Details",
      render: (_, record) => (
        record?.tracking_data?.meta_details?.clicked_buttons?.length > 0 ? (
          record.tracking_data.meta_details.clicked_buttons.map((btn, index) => (
            <Button key={index} size="small" style={{ marginRight: 4 }}>
              {btn.replace(/[-_]/g, " ")}
            </Button>
          ))
        ) : (
          <span style={{ color: "#999" }}>Empty</span>
        )
      )
    },
    {
      title: "Action",
      render: (_, record) => (
        <Button type="link" onClick={() => showModal(record)}>
          Details
        </Button>
      ),
    },
  ];

  const pagination_on_change = async (page, size = page_size) => {
    set_pagination_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("campaign_id", campaign_id);
      FORM_DATA.append("page", page);
      FORM_DATA.append("page_size", size);

      if (departmentValue) {
  FORM_DATA.append("department", departmentValue);
}

      if (statusValue && statusValue !== "" && statusValue !== "all") {
        FORM_DATA.append("status", Number(statusValue));
      } else if (emailValue) {
        FORM_DATA.append("email", emailValue);
      }

      const API_CALL = await LIST_CAMPAIGN_USER(FORM_DATA);

      if (API_CALL?.data?.status) {
        set_table_data(API_CALL.data.data);
        set_current_page(API_CALL.data.current_page);
        set_total_pages(API_CALL.data.total_pages);
        set_total_users(API_CALL.data.total_users);
      } else {
        set_table_data([]);
      }
    } catch (err) {
      console.error("Pagination API Error:", err);
    } finally {
      set_pagination_loader(false);
      if (typeof setLoadingUsers === "function") setLoadingUsers(false);
    }
  };


  const handleInput = (e) => {
    const value = e.target.value;
    setEmailValue(value);

    if (statusValue !== "") {
      setStatusValue("");
    }

    // use the debounced fetchResults wrapper
    const FORM_DATA = new FormData();
    FORM_DATA.append("campaign_id", campaign_id);
    FORM_DATA.append("email", value);
    fetchResultsDebounced(FORM_DATA);
  };

  const handleStatusChange = (val) => {
    setStatusValue(val);

    const FORM_DATA = new FormData();
    FORM_DATA.append("campaign_id", campaign_id);

    if (val === "all") {
      setEmailValue("");
      fetchResultsDebounced(FORM_DATA);
      return;
    }

    FORM_DATA.append("status", Number(val));
    fetchResultsDebounced(FORM_DATA);
  };

  return (
    <Card>
      <Row gutter={16} style={{ marginBottom: 12 }}>
        <Col span={12}>
          <h2>Campaign User List</h2>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginBottom: 12, justifyContent: "space-between" }}>
        <Col span={12}>
          <Input
            addonBefore={selectBefore}
            style={{ width: "100%" }}
            placeholder="Search by email"
            value={emailValue}
            onChange={handleInput}
            size="large"
            allowClear
          />
        </Col>

        <Col span={10} style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>

  {/* Department Filter */}
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <span style={{ fontSize: "16px", fontWeight: 500 }}>Department:</span>
    <Select
      showSearch
      allowClear
      placeholder="Select Department"
      style={{ width: 180 }}
      value={departmentValue || undefined}
      optionFilterProp="children"
      onChange={handleDepartmentChange}
      filterOption={(input, option) =>
        option.children.toLowerCase().includes(input.toLowerCase())
      }
    >
      {departmentList.map((dep, index) => (
        <Option key={index} value={dep}>
          {dep}
        </Option>
      ))}
    </Select>
  </div>

  {/* Status Filter (unchanged) */}
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <span style={{ fontSize: "16px", fontWeight: 500}}>Status:</span>
    <Select
              placeholder="Filter by status"
              style={{ flex: 1, width: "110px" }}
              size="middle"
              allowClear
              value={statusValue === "" ? undefined : statusValue}
              onChange={handleStatusChange}
              options={STATUS_OPTIONS.map((s) => ({ label: s.label, value: s.value }))}
            />
  </div>
</Col>
      </Row>


      {loader ? (
        <CulsightPageLoader />
      ) : pagination_loader ? (
        <div style={{ textAlign: "center", padding: "60px" }}>
          <Spin indicator={<LoadingOutlined spin />} size="large" />
        </div>
      ) : (
        <>
          <Table
            columns={columns}
            pagination={false}
            dataSource={table_data || []}
            style={{ marginTop: "15px" }}
            rowKey={(record) => record.email}
          />

          {total_pages > 0 && (
            <div style={{ float: "right", marginTop: "20px" }}>
              <Pagination
                current={current_page}
                total={total_users}
                pageSize={page_size}
                showSizeChanger
                pageSizeOptions={['10', '20', '50', '100']}
                onShowSizeChange={(page, size) => {
                  set_page_size(size);
                  set_current_page(1);
                  pagination_on_change(1, size);
                }}
                onChange={(page) => {
                  pagination_on_change(page, page_size);
                }}
                style={{ display: "inline-block" }}
                className="no-search-pagination"
              />
              <style>
                {`
    .no-search-pagination .ant-select-selection-search-input {
      display: none !important;
    }
  `}
              </style>
            </div>
          )}
        </>
      )}

      {/* Modal with Steps */}
      <Modal
        title="User Steps"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        {selectedUser?.tracking_data?.tracking_status < 200 ? (
          <Steps
            direction="vertical"
            current={Math.min(selectedUser.tracking_data.tracking_status || 0, 3)}
          >
            <Step title="Email Sent" description="User received the email." />
            <Step
              title="Email Opened"
              description={
                selectedUser.tracking_data.tracking_status > 0 &&
                  selectedUser.tracking_data.tracking_status < 200 ? (
                  <>
                    <div style={{ fontWeight: 600 }}>
                      User opened the email.
                    </div>

                    {/* Open Email Logs */}
                    <div style={{ marginTop: 8 }}>
                      {selectedUser?.tracking_data?.meta_details?.email_open_logs?.length > 0 ? (
                        selectedUser.tracking_data.meta_details.email_open_logs.map((log, index) => (
                          <div
                            key={index}
                            style={{
                            
                              padding: "6px 10px",
                              borderRadius: "6px",
                              marginBottom: "6px",
                              fontSize: "12px"
                            }}
                          >
                            <div><b>IP & Browser:</b> {log.apl_logs}</div>
                            <div><b>Time:</b> {log.timespamp}</div>
                          </div>
                        ))
                      ) : (
                        <span style={{ color: "#999" }}>No open logs</span>
                      )}
                    </div>
                  </>
                ) : (
                  "Remain"
                )
              }
            />

            <Step
              title="Clicked Link"
              description={
                selectedUser.tracking_data.tracking_status > 1 &&
                  selectedUser.tracking_data.tracking_status < 200 ? (
                  <>
                    <div style={{ fontWeight: 600 }}>
                      Current : {selectedUser?.tracking_data?.clicked_broswer}
                    </div>

                    {/* Clicked Logs */}
                    <div style={{ marginTop: 8 }}>
                      {selectedUser?.tracking_data?.meta_details?.clicked_logs?.length > 0 ? (
                        selectedUser.tracking_data.meta_details.clicked_logs.map((log, index) => (
                          <div
                            key={index}
                            style={{
                            
                              padding: "6px 10px",
                              borderRadius: "6px",
                              marginBottom: "6px",
                              fontSize: "12px"
                            }}
                          >
                            <div><b>IP & Browser:</b> {log.apl_logs}</div>
                            <div><b>Time:</b> {log.timespamp}</div>
                          </div>
                        ))
                      ) : (
                        <span style={{ color: "#999" }}>No Click Logs</span>
                      )}
                    </div>
                  </>
                ) : (
                  "Remain"
                )
              }
            />

            <Step title="Submitted Data" description={selectedUser.tracking_data.tracking_status > 2 && selectedUser.tracking_data.tracking_status < 200 ? <>

              <h3 style={{ color: "#59f259" }}>Form Data</h3>
              {selectedUser?.tracking_data?.form_submit && Object.entries(selectedUser?.tracking_data?.form_submit).map(([key, value], index) =>
              (<>
                <div key={index}> <span><b style={{ color: "#ff9696", textTransform: "capitalize", fontSize: "12px" }}>{key}</b></span> = <span><b style={{ color: "rgb(123 225 209)", textTransform: "capitalize", fontSize: "12px" }}>{value}</b></span><br></br></div>
              </>)
              )}
              <br></br>
              {selectedUser?.tracking_data?.clicked_broswer}
            </> : 'Remain'} />
          </Steps>
        ) : (
          <p>No tracking data available.</p>
        )}
      </Modal>
    </Card>
  );
}

export default CampaignUsers;
